const PATTERN = /^\s*pre-execution risk/i;

function getTextContent(node: any): string {
  if (!node.children) return '';
  return (node.children as any[])
    .map((c: any) => (c.type === 'text' ? c.value : getTextContent(c)))
    .join('');
}

function isBlockHeading(node: any): boolean {
  return node.type === 'element' && /^h[1-4]$/.test(node.tagName);
}

export const collapsibleRiskPlugin = () => (tree: any) => {
  const children: any[] = tree.children || [];
  const out: any[] = [];
  let i = 0;

  while (i < children.length) {
    const node = children[i];

    if (node.type === 'element' && node.tagName === 'h4' && PATTERN.test(getTextContent(node))) {
      const body: any[] = [];
      i++;
      while (i < children.length && !isBlockHeading(children[i])) {
        body.push(children[i]);
        i++;
      }
      out.push({
        type: 'element',
        tagName: 'details',
        properties: { className: ['cr-risk-details'] },
        children: [
          {
            type: 'element',
            tagName: 'summary',
            properties: { className: ['cr-risk-summary'] },
            children: node.children
          },
          ...body
        ]
      });
    } else {
      out.push(node);
      i++;
    }
  }

  tree.children = out;
};
